import { render, staticRenderFns } from "./StorageSpaceUpdateScreen.vue?vue&type=template&id=cc9776ea&"
import script from "./StorageSpaceUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports